
import { defineComponent, onMounted, ref, watch } from "vue";
import { useStore } from "vuex";
import { RootState } from "@/@types/store";
import { BaseLayoutFooter, SendVeriButton } from "@/components/Common";
import { mobileReg } from "@/utils/regs";

import { actionTypes } from "@/store/types";
import { useRouter } from "vue-router";

export default defineComponent({
  components: {
    BaseLayoutFooter,
    SendVeriButton,
  },

  setup() {
    const store = useStore<RootState>();
    const router = useRouter();
    const loginLoading = ref(false);
    const loginForm = ref<any>(null);
    const formData = ref({
      authorization_type: "mobile",
      mobile: "",
      mobile_code: "",
      password: "",
      checkPrivatePolicy: "",
    });
    const checkPrivatePolicyIsError = ref(false);
    const rules = {
      mobile: [
        { required: true, message: "请输入手机号", trigger: "blur" },
        {
          pattern: mobileReg,
          message: "手机号不符合格式",
          trigger: "blur",
        },
      ],
      password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      mobile_code: [
        { required: true, message: "请输入验证码", trigger: "blur" },
      ],
      checkPrivatePolicy: [
        {
          validator: (rule: any, value: boolean, callback: any) => {
            if (!value) {
              checkPrivatePolicyIsError.value = true;
              callback(new Error("请先阅读并勾选隐私政策及服务协议"));
            } else {
              checkPrivatePolicyIsError.value = false;
              callback();
            }
          },
        },
      ],
    };

    watch(
      () => formData.value.checkPrivatePolicy,
      () => {
        loginForm.value && loginForm.value.validateField("checkPrivatePolicy");
      }
    );

    function openDialog() {
      window.open("https://mtoc.zto.com/agreement/privacy-policy.html");
    }

    function changeLoginType(type: string) {
      formData.value.authorization_type = type;
      loginForm.value && loginForm.value.clearValidate();
      checkPrivatePolicyIsError.value = false;
    }

    function sendVeriMessage() {
      return new Promise((resolve, reject) => {
        loginForm.value &&
          loginForm.value.validateField("mobile", (errorMessage: string) => {
            if (errorMessage) {
              reject(new Error(errorMessage));
              return;
            }
            resolve({
              action: "login",
              phone: formData.value.mobile,
            });
          });
      });
    }

    async function loginAction() {
      loginForm.value &&
        loginForm.value.validate(async (valid: boolean) => {
          if (!valid) return;
          const formDataRef = formData.value;
          try {
            loginLoading.value = true;
            await store.dispatch(`user/${actionTypes.USER_LOGIN}`, {
              authorization_type: formDataRef.authorization_type,
              authorization:
                formDataRef.authorization_type === "smsotp"
                  ? `${formDataRef.mobile} ${formDataRef.mobile_code}`
                  : `${formDataRef.mobile} ${formDataRef.password}`,
            });
            await store.dispatch(`config/${actionTypes.GET_ENUM_MAP}`);
            await store.dispatch(`config/${actionTypes.GET_MENUINFO_LIST}`);
            await router.replace("/admin");
            // if (store.state.user.userInfo.bindElcSheet) {
            //   await router.replace("/admin");
            // } else {
            //   await router.replace({
            //     name: "/admin/base-setting/bes-manager",
            //     params: {
            //       showBindElcSheet: store.state.user.userInfo.bindElcSheet
            //         ? 0
            //         : 1,
            //     },
            //   });
            // }
            loginLoading.value = false;
          } catch (e) {
            loginLoading.value = false;
          }
        });
    }

    onMounted(async () => {
      if (store.state.user.isLogin) {
        await store.dispatch(`user/${actionTypes.GET_USER_INFO}`)
        if (store.state.user.userInfo.bindElcSheet) {
          router.replace("/admin");
        } else {
          router.replace("/admin/base-setting/bes-manager/bes-list");
        }
      }
    });

    return {
      loginLoading,
      loginForm,
      formData,
      rules,
      checkPrivatePolicyIsError,
      openDialog,
      changeLoginType,
      sendVeriMessage,
      loginAction,
    };
  },
});
